import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';

function useArchiveIncompleteInvestment() {
  return api.incompleteInvestment.archive.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Subscription archived successfully.',
    }),
  );
}

export default useArchiveIncompleteInvestment;
